import api from "./api.service";
import router from "../router";
import { store } from "../store/store";

const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;

export default class extends api {
  static auth(username, password) {
    return this.apiRequest(
      API_SUFFIX + "/api/login_check",
      { username: username, password: password },
      "POST"
    )
      .then(data => {
        return this.whoAmI(true);
      })
      .then(data => {
        store.commit("setAuthed", true);
      })
      .catch(error => {
        throw new Error();
      });
  }

  static whoAmI(redirectRequired = false) {
    this.apiRequest(API_SUFFIX + "/api/me", {}, "GET").then(data => {
      store.commit("setUser", data);
      if (redirectRequired) {
        if (store.getters.getAuthed == true) {
          router.push("/scenarios");
        }
      }
      return data;
    });
  }

  static validateEmail(username) {
    return this.apiRequest(
      API_SUFFIX + "/api/validate_username",
      { username: username },
      "POST"
    )
      .then(data => {
        router.push("/scenarios");
        return data;
      })
      .catch(() => {
        throw new Error();
      });
  }

  static logout() {
    this.apiRequest(API_SUFFIX + "/api/me/logout", {}, "GET").then(() => {
      store.commit("setUser", {});
      store.commit("setAuthed", false);
    });
  }

  static requestPasswordReset(username) {
    return this.apiRequest(
      API_SUFFIX + "/password/send-email",
      {
        username: username
      },
      "POST"
    )
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static requestPasswordResetLoggedIn() {
    return this.apiRequest(
      API_SUFFIX + "/api/me/password/send-email",
      {},
      "POST"
    )
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static changePassword(newPassword) {
    return this.apiRequest(
      API_SUFFIX + "/api/me/password/update",
      {
        password: newPassword
      },
      "POST"
    )
      .then(data => {
        store.commit("setChangedPassword", true);
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static requestDetailsUpdate(userId, firstName, lastName, telephoneNumber) {
    return this.apiRequest(
      API_SUFFIX + "/api/me/update-details",
      {
        userId: userId,
        firstName: firstName,
        lastName: lastName,
        telephoneNumber: telephoneNumber
      },
      "POST"
    )
      .then(data => {
        return this.whoAmI();
      })
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static getUser(userId) {
    return this.apiRequest(API_SUFFIX + "/api/user/" + userId, {}, "GET")
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static getUserDetails(uuId) {
    return this.apiRequest(API_SUFFIX + "/api/user-details/" + uuId, {}, "GET")
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static changeUserPrivacy(isPublic) {
    return this.apiRequest(
      API_SUFFIX + "/api/me/update-privacy",
      {isPublic},
      "POST"
    ).then((data) => {
      return data;
    });
  }
}
